//@flow

export function safeNotify(callback: ?Function, ...params: any) {
  if (callback) {
    callback(...params);
  }
}
